import { get } from 'lodash'

const migratedCentres = {
  newmarket: 730,
  airportwest: 890,
  woden: 689,
  carousel: 889,
  coomera: 920,
  geelong: 897,
  helensvale: 898,
  innaloo: 901,
  plentyvalley: 912,
  westlakes: 915,
  mtdruitt: 907,
  knox: 1006,
  northlakes: 908,
  albany: 880,
  manukau: 883,
  stlukes: 884,
  belconnen: 885,
  eastgardens: 893,
  riccarton: 882,
  kotara: 902,
  penrith: 910,
  southland: 911,
  teatreeplaza: 914,
  tuggerah: 918,
  whitfordcity: 917,
  warringahmall: 913,
  liverpool: 904,
  marion: 906,
  burwood: 886,
  booragoon: 1094,
  carindale: 887,
  doncaster: 894,
  hornsby: 899,
  gardencity: 896,
  parramatta: 909,
  fountaingate: 895,
  bondijunction: 888,
  sydney: 916,
  hurstville: 900,
  chatswood: 891,
  chermside: 892,
  miranda: 905,
}

function isMigrated(centre) {
  return get(migratedCentres, centre, null)
}

export default isMigrated
